"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ChevronRight } from "lucide-react";
import NavLink from "@/components/header/shared/NavLink";
interface DrillDownItemProps {
  title: string;
  url?: string;
  hasChildren?: boolean;
  onClick?: () => void;
  isActive?: boolean;
  onLinkClick?: () => void;
}
const DrillDownItem: React.FC<DrillDownItemProps> = t0 => {
  const $ = _c(14);
  const {
    title,
    url,
    hasChildren,
    onClick,
    onLinkClick
  } = t0;
  const isSpecialEdit = title?.trim().toUpperCase() === "FRIENDSHIP DAY EDIT" || title?.trim().toUpperCase() === "MEANINGFUL DIWALI";
  if (hasChildren) {
    const t1 = `font-serif text-[15px] ${isSpecialEdit ? "text-[#037a6a] font-bold" : ""}`;
    let t2;
    if ($[0] !== t1 || $[1] !== title) {
      t2 = <span className={t1}>{title}</span>;
      $[0] = t1;
      $[1] = title;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ChevronRight size={18} className="text-gray-400" />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== onClick || $[5] !== t2) {
      t4 = <button onClick={onClick} className="flex items-center justify-between w-full px-4 py-4 text-left transition-colors text-gray-700 hover:bg-gray-50 border-b border-gray-50 last:border-none">{t2}{t3}</button>;
      $[4] = onClick;
      $[5] = t2;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const t1 = url || "#";
  const t2 = `font-serif text-[15px] ${isSpecialEdit ? "text-[#037a6a] font-bold" : ""}`;
  let t3;
  if ($[7] !== t2 || $[8] !== title) {
    t3 = <span className={t2}>{title}</span>;
    $[7] = t2;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onLinkClick || $[11] !== t1 || $[12] !== t3) {
    t4 = <div className="border-b border-gray-50 last:border-none"><NavLink href={t1} onClick={onLinkClick} className="flex items-center justify-between w-full px-4 py-4 text-left transition-colors text-gray-700 hover:bg-gray-50">{t3}</NavLink></div>;
    $[10] = onLinkClick;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default DrillDownItem;